module.exports = __webpack_public_path__ + "img/bg-02.a8221491.png";